var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemRowsStacked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.667 8.667a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3.333a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2zM3.333 10a.667.667 0 0 0-.666.667v2c0 .368.298.666.666.666h9.334a.666.666 0 0 0 .666-.666v-2a.667.667 0 0 0-.666-.667zm9.334-8.667a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3.333a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2zM3.333 2.667a.666.666 0 0 0-.666.666v2c0 .368.298.667.666.667h9.334a.667.667 0 0 0 .666-.667v-2a.666.666 0 0 0-.666-.666z",
  clipRule: "evenodd"
})));
export default SvgGemRowsStacked;